


const NotFound = () => {

  return ( 
    <h1>NotFound</h1>
  )
}

export default NotFound